import { FieldInput, Form, FormProps, useFormState } from '@isbj-redesign/final-form-components'
import { Aligns, Badge, Button, ButtonType, Col, Collapsable, Color, Display, FlexWrap, generateId, Justify, Row } from '@isbj-redesign/frontend-components'
import React, { useMemo, useState } from 'react'
import ArrowIcon from './ArrowIcon'

type FormType = { suche?: string }

type TableFilterProps = {
    onSubmit: (values: { suche?: string }) => void
    children?: React.ReactElement
} & FormProps<{ suche: string }>

export function TableFilter({ children, ...fromProps }: TableFilterProps) {
    const [expanded, setExpanded] = useState(false)
    const key = useMemo(() => generateId(), [])

    return (
        <Form<FormType> {...fromProps}>
            {({ handleReset, handleSubmit }) => (
                <Row justifyContent={Justify.Between}>
                    <Col size={{ xs: 12, md: 8 }} order={{ xs: 1 }} display={Display.Flex}>
                        <div className="d-flex-inline">
                            <FieldInput id="suche" name="suche" label="Suche" />
                        </div>
                        {children && (
                            <Button
                                title="Filter anpassen"
                                color="link"
                                type={ButtonType.Button}
                                marginBottom={3}
                                alignSelf={Aligns.End}
                                onClick={() => setExpanded((old) => !old)}
                                ariaControls={`erweiterter-filter-suche-${key}`}
                                ariaExpanded={expanded}
                            >
                                <ActiveFilter className="mr-2" />
                                Filter anpassen
                                <ArrowIcon direction={expanded ? 'bottom' : 'right'} className="ml-2" />
                            </Button>
                        )}
                    </Col>

                    <Col xs={12} order={{ xs: 3 }}>
                        {children && (
                            <Collapsable id={`erweiterter-filter-${key}`} aria-labelledby="" collapsed={!expanded}>
                                {children}
                            </Collapsable>
                        )}
                    </Col>

                    <Col
                        size={{ xs: 12, md: 4 }}
                        order={{ xs: 2 }}
                        display={{ xs: Display.Block, md: Display.Flex }}
                        flexWrap={FlexWrap.WrapReverse}
                        marginBottom={{ xs: 3, md: 0 }}
                        justifyContent={{
                            md: Justify.End,
                        }}
                        alignItems={Aligns.Center}
                    >
                        <Button
                            title="Filter zurücksetzen"
                            type={ButtonType.Reset}
                            onClick={() => {
                                handleReset()
                                handleSubmit()
                            }}
                            marginLeft={{ xs: 0, md: 1 }}
                            color="link"
                            outline
                        >
                            Filter zurücksetzen
                        </Button>
                        <Button title="Suchen">Suchen</Button>
                    </Col>
                </Row>
            )}
        </Form>
    )
}

function ActiveFilter({ className }: { className: string }) {
    const { values } = useFormState()
    const activeFilters = useMemo(() => Object.values(values).filter((it) => it !== undefined && it !== null).length, [values])

    return activeFilters > 0 ? (
        <Badge badgeColor={Color.Primary} className={className}>
            Aktive Filter {activeFilters}
        </Badge>
    ) : null
}
